var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model-item",
        {
          staticStyle: { width: "255px" },
          attrs: { label: "附件：", prop: "fileId" }
        },
        [
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c("qiXinKaiLiFileUpload", {
                ref: "fileUpload",
                attrs: {
                  accept: ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.pdf,.PDF,.zip,.ZIP",
                  paramObj: _vm.uploadParam,
                  name: "file",
                  limit: "50"
                },
                on: {
                  "update:paramObj": function($event) {
                    _vm.uploadParam = $event
                  },
                  "update:param-obj": function($event) {
                    _vm.uploadParam = $event
                  },
                  uploadOk: _vm.uploadOk
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-color-orange img-tip" }, [
                _vm._v(
                  "\n温馨提示：1、每次上传最多不超过50个文件\n                  2、支持PNG、JPG、JPEG、PDF、ZIP，单个文件不能超过100M\n       "
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72a0c870", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a0c870","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/other-file-upload.vue
// module id = wIpe
// module chunks = 1